module.exports = __webpack_public_path__ + "static/media/vessel.8e65acf4.svg";